import React, { useContext } from 'react';

import { Flex } from '@circleci/compass';
import { useRouter } from 'next/router';

import { Header } from '~/components/Header';
import { Banner } from '~/components/HeaderWithBanner/Banner';
import { SearchResultsPanel } from '~/components/SearchResultsPanel';
import BannerContext from '~/contexts/BannerContext';
import { styled } from '~/styled';
import { HEADER_HEIGHT } from '~/utils/global';

const Position = styled.div`
  position: fixed;
  top: 0;
  z-index: 999;
  width: 100%;
`;

const HeaderHeight = styled.div`
  visibility: hidden;
  height: ${HEADER_HEIGHT};
  width: 100%;
`;

const SearchResultsPanelWrapper = styled(Flex)(`
    width: 100%;
    top: ${HEADER_HEIGHT};
  `);

export const HeaderWithBanner = () => {
  const router = useRouter();
  const {
    currentBanner,
    handleBannerClose,
    showCurrentBanner,
    isBannerClosing,
  } = useContext(BannerContext);

  const currentPath = router.asPath;
  let activeTab;

  if (currentPath === '/') {
    activeTab = 'home';
  }
  if (currentPath.includes('/orbs')) {
    activeTab = 'orbs';
  }
  if (currentPath.includes('/images') || currentPath.includes('/machine')) {
    activeTab = 'images';
  }

  const fullHeader = (
    <>
      {showCurrentBanner && (
        <Banner
          bannerId={currentBanner}
          closeBanner={handleBannerClose}
          bannerHidden={isBannerClosing}
        />
      )}
      <Header activeTab={activeTab} />
      <SearchResultsPanelWrapper>
        <SearchResultsPanel />
      </SearchResultsPanelWrapper>
    </>
  );

  return (
    <div
      className={isBannerClosing ? 'banner-closing' : ''}
      data-testid="headerWrapper"
    >
      <Position>{fullHeader}</Position>
      {/* Second header with visibility hidden to "push" content dynamically
      since first one is "position: fixed;" */}
      <HeaderHeight />
    </div>
  );
};
